import IconLetter from '@/components/icons/IconLetter.vue';
import IconTime from '@/components/icons/IconTime.vue';
import IconPhone from '@/components/icons/IconPhone.vue';
import IconLocation from '@/components/icons/IconLocation.vue';
import ContactsForm from '@/modules/StaticPages/Contacts/ContactsForm/index.vue';

export default {
  name: 'ContactsCard',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isHasForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  components: { ContactsForm, IconLocation, IconPhone, IconTime, IconLetter },

  created() {},
  mounted() {},
  computed: {
    isExtended() {
      return !!this.data.map;
    }
  },

  methods: {}
};
